import { Emoji } from "emoji-picker-react";

import { Flex } from "@/components/layout/flexbox";
import { RoleplayType } from "@/graphql";

export function CollectionTitle({ collection }: { collection: RoleplayType }) {
  return (
    <Flex alignItems="center" style={{ gap: 8 }}>
      <Emoji unified={collection.emojiUnicode.toLowerCase()} size={24} />
      {collection.name}
    </Flex>
  );
}
